<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      高新南站<br>
站点介绍<br>
高新南站位于白石路与科技南路交叉口东侧，沿着白石路呈东西走向布置，车站周边用地属性为三类住宅用地、新型产业用地、现状建筑，A、B出入口均设置于白石路南侧，并分别设接驳通道连接科技生态园四区、二区地下室，周边是高新公寓多层住宅区，C、D出入口均设置与白石路北侧,周边是豪威科技大厦高层写字楼及在建中的深圳科技生态园。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:12	23:52	9号线	3分50秒	5分55秒<br>
文锦	06:26	23:18	9号线	3分50秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:13	23:51	9号线	4分25秒	5分55秒<br>
文锦	06:26	23:18	9号线	4分25秒	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:12	00:52	9号线	4分钟	5分55秒<br>
文锦	06:26	00:18	9号线	4分钟	5分55秒<br><br>

站点出口信息<br><br>
A出入口:<br>
白石路南侧（西）、科技南路东侧（南)、科技生态园三、四区<br><br>
B出入口:<br>
白石路南侧（东）、高新南环路东侧、科技生态园二区、南山区行政服务大厅创新广场分厅<br><br>
C出入口:<br>
白石路北侧（东）、科技南八路东侧、沙河西路西侧、工勘大厦、粤美特大厦<br><br>
D出入口:<br>
白石路北侧（西）、科技南路东侧（北）、深圳国家工程实验室大楼、深圳数字技术园、高新公寓<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 高新南站<br>
高峰专线54、M355、49、高峰专线102<br><br>
B出入口:<br>
公交站名： 高新南站<br>
325、高峰专线54、M200、高峰专线165<br><br>
D出入口:<br>
公交站名： 高新南站<br>
高峰专线54、M355、高峰专线102<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "jiuhaoxian",
            title: "9号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>